// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';
import get from 'lodash/get';
import adsConfig from '../../../config/ads';
import { buildPostAdModel } from '../../../utils/ad_util';

export default function(state = {}, action) {
  const { store } = action;
  const typeMap = {
    PRODUCT_INDEX_SECTION_PAGE_LOADING() {
      return {
        isLoading: true,
        productIndexSectionPage: action.productIndexSectionPage
      };
    },
    PRODUCT_INDEX_SECTION_PAGE_LOADED() {
      const currentState = store.getState();
      const site = get(currentState, 'config.site') || 'fastcompany';
      const adModelData = buildPostAdModel(
        adsConfig,
        site,
        'innovationbydesign',
        'categoryPage'
      );

      // Override this for MCP
      adModelData.model.adzone = 'innovation/innovationbydesign';
      return {
        isLoading: false,
        data: action.productIndexSectionPage,
        ads: adModelData
      };
    },
    PRODUCT_INDEX_SECTION_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.productIndexSectionPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
